;(function ($) {
	'use strict';

	$(window).on('load', initialize_menuMain);
	$(window).on('resize', initialize_menuMain);

	function initialize_menuMain() {
		var $body              = $('body');
		var $mainMenu          = $('.main-menu');
		var $globalSubmenus    = $('.main-menu__submenu-container');
		var $parentItem        = $('.menu-item__has-children');
		var $submenuToggles    = $('.main-menu__group-expander');
		var $mobileMenuToggle  = $('.main-menu__toggle');

		$globalSubmenus.addClass('ready');

		// Desktop behavior
		if ( $mobileMenuToggle.css('display') === 'none' ) {
			$parentItem
				.off('mouseenter.menuMain mouseleave.menuMain')
				.on({
					'mouseenter.menuMain': function() {
						$(this).closest('.main-menu__list-item').attr('aria-expanded', 'true');
						$(this).addClass('submenu--revealed');
						$body.addClass('submenu-is-open');
					},
					'mouseleave.menuMain': function() {
						$(this).closest('.main-menu__list-item').attr('aria-expanded', 'false');
						$(this).removeClass('submenu--revealed');
						$body.removeClass('submenu-is-open');
					}
				});

			$submenuToggles
				.off('click.menuMain')
				.on('click.menuMain', function() {
					const $parent = $(this).closest('.menu-item__has-children');
					if (!$parent.hasClass('submenu--revealed')) {
						if ( $mainMenu.find('.submenu--revealed').length ) {
							$mainMenu.find('.submenu--revealed')
								.find('.main-menu__group-expander')
								.trigger('click');
						}
						$parent
							.attr('aria-expanded', 'true')
							.addClass('submenu--revealed');
						$body.addClass('submenu-is-open');
					}
					else {
						$parent
							.attr('aria-expanded', 'false')
							.removeClass('submenu--revealed');
						$body.removeClass('submenu-is-open');
					}
				});
		}
		else {
			// Mobile: tear down desktop handlers on resize down
			$parentItem.off('mouseenter.menuMain mouseleave.menuMain');
			$submenuToggles.off('click.menuMain');
		}
	}
})(jQuery);
